import {
  UPDATE_TEXT_VALUE,
  UPDATE_FONT_SIZE,
  UPDATE_FONT,
  UPDATE_LETTER_SPACING,
  UPDATE_TRANSFORM_TYPE,
  UPDATE_TRANSFORM_AMOUNT,
  ADD_TEXT,
  DELETE_TEXT,
  UPDATE_TEXT_DIMENSIONS,
  UPDATE_UNIFIED_FONT,
  UPDATE_UNIFIED_FONT_SIZE,
  UPDATE_TEXT_IMAGE,
  FIRST_TEXT_INITIAL_POSITION,
  NEW_TEXT_INITIAL_POSITION,
} from "../../actions";
import DefaultFont from "../../components/Tools/TypeTools/DefaultFont";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_TEXT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };

          if (layer.layer_id === action.payload.layerId) {
            let fontId = DefaultFont.ID,
              fontName = DefaultFont.NAME,
              fontSize = 20,
              baseBottomPosition = 0,
              baseTextBottomPosition = 0,
              baseImageBottomPosition = 0;

            if (layer.text_elements.length) {
              fontId =
                layer.text_elements[layer.text_elements.length - 1].font.id;
              fontName =
                layer.text_elements[layer.text_elements.length - 1].font.name;
              fontSize =
                layer.text_elements[layer.text_elements.length - 1].size;

              // Get furthest bottom positioned text element
              baseTextBottomPosition = Math.max.apply(
                Math,
                layer.text_elements.map((obj) => {
                  return obj.height + obj.top_position;
                }),
              );
            }

            if (layer.image_elements.length) {
              // Get furthest bottom positioned image element
              baseImageBottomPosition = Math.max.apply(
                Math,
                layer.image_elements.map((obj) => {
                  return obj.height + obj.top_position;
                }),
              );
            }

            baseBottomPosition =
              baseTextBottomPosition > baseImageBottomPosition
                ? baseTextBottomPosition
                : baseImageBottomPosition;

            if (!layer.text_elements.length) {
              baseBottomPosition = layer.height / 2;
            }

            layer.text_elements.push({
              id:
                layer.text_elements.reduce(
                  (maxId, textfield) => Math.max(textfield.id, maxId),
                  -1,
                ) + 1,
              // TODO This should load the product's default font
              font: {
                id: fontId,
                name: fontName,
              },
              size: fontSize,
              letter_spacing: 0,
              left_position: 0.5,
              rotation: 0,
              top_position: baseBottomPosition,
              transform_type: null,
              transform_amount: 45,
              text: "New Text Field",
              first_text_field: layer.text_elements.length ? false : true,
              new_text: true,
            });
          }
          return layer;
        }),
      };

    case DELETE_TEXT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.text_elements = layer.text_elements.filter(
              (textField) => textField.id !== action.payload.id,
            );
          }
          return layer;
        }),
      };

    case UPDATE_TRANSFORM_TYPE:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.text_elements = [
              ...layer.text_elements.slice(0, action.payload.index),
              {
                ...layer.text_elements[action.payload.index],
                transform_type: action.payload.transform_type,
              },
              ...layer.text_elements.slice(action.payload.index + 1),
            ];
          }
          return layer;
        }),
      };

    case UPDATE_LETTER_SPACING:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.text_elements = [
              ...layer.text_elements.slice(0, action.payload.index),
              {
                ...layer.text_elements[action.payload.index],
                letter_spacing: action.payload.letter_spacing,
              },
              ...layer.text_elements.slice(action.payload.index + 1),
            ];
          }
          return layer;
        }),
      };

    case UPDATE_TRANSFORM_AMOUNT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.text_elements = [
              ...layer.text_elements.slice(0, action.payload.index),
              {
                ...layer.text_elements[action.payload.index],
                transform_amount: parseInt(action.payload.transform_amount, 10),
              },
              ...layer.text_elements.slice(action.payload.index + 1),
            ];
          }
          return layer;
        }),
      };

    case UPDATE_TEXT_VALUE:
      let newTextState = { ...state };
      newTextState.layer_set = newTextState.layer_set.map((old_layer) => {
        const layer = { ...old_layer };
        if (layer.layer_id === action.payload.layerId) {
          layer.text_elements = [
            ...layer.text_elements.slice(0, action.payload.index),
            {
              ...layer.text_elements[action.payload.index],
              text: action.payload.value,
            },
            ...layer.text_elements.slice(action.payload.index + 1),
          ];
        }
        return layer;
      });
      return newTextState;

    case UPDATE_FONT_SIZE:
      let newTextSizeState = { ...state };
      newTextSizeState.layer_set = newTextSizeState.layer_set.map(
        (old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.text_elements = [
              ...layer.text_elements.slice(0, action.payload.index),
              {
                ...layer.text_elements[action.payload.index],
                size: action.payload.value.trim(),
              },
              ...layer.text_elements.slice(action.payload.index + 1),
            ];
          }
          return layer;
        },
      );
      return newTextSizeState;

    case UPDATE_FONT:
      let newFontState = { ...state };
      newFontState.layer_set = newFontState.layer_set.map((old_layer) => {
        const layer = { ...old_layer };
        if (layer.layer_id === action.payload.layerId) {
          layer.text_elements = [
            ...layer.text_elements.slice(0, action.payload.index),
            {
              ...layer.text_elements[action.payload.index],
              font: {
                id: action.payload.font.id,
                name: action.payload.font.name,
                thumbnail: action.payload.font.thumbnail,
              },
            },
            ...layer.text_elements.slice(action.payload.index + 1),
          ];
        }
        return layer;
      });
      return newFontState;

    case UPDATE_UNIFIED_FONT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.allow_text) {
            layer.text_elements = layer.text_elements.map((element) => {
              return {
                ...element,
                font: {
                  id: action.payload.font.id,
                  name: action.payload.font.name,
                  thumbnail: action.payload.font.thumbnail,
                },
              };
            });
          }
          return layer;
        }),
      };

    case UPDATE_UNIFIED_FONT_SIZE:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.allow_text) {
            layer.text_elements = layer.text_elements.map((element) => {
              return {
                ...element,
                size: action.payload.value,
              };
            });
          }
          return layer;
        }),
      };

    case UPDATE_TEXT_DIMENSIONS:
      let newDimensionsState = { ...state };
      const scale = 72 * state.preview_scale;

      newDimensionsState.layer_set = newDimensionsState.layer_set.map(
        (old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.text_elements = [
              ...layer.text_elements.slice(0, action.payload.index),
              {
                ...layer.text_elements[action.payload.index],
                width: action.payload.width / scale,
                height: action.payload.height / scale,
              },
              ...layer.text_elements.slice(action.payload.index + 1),
            ];
          }
          return layer;
        },
      );
      return newDimensionsState;

    case UPDATE_TEXT_IMAGE:
      let newImageState = { ...state };

      newImageState.layer_set = newImageState.layer_set.map((old_layer) => {
        const scale = 72 * state.preview_scale;
        const layer = { ...old_layer };

        if (layer.layer_id === action.payload.layerId) {
          layer.text_elements = [
            ...layer.text_elements.slice(0, action.payload.index),
            {
              ...layer.text_elements[action.payload.index],
              image: action.payload.image,
              width: action.payload.width / scale,
              height: action.payload.height / scale,
              first_text_field: false,
              new_text: false,
              current_layer_id: action.payload.currentLayerId,
            },
            ...layer.text_elements.slice(action.payload.index + 1),
          ];
        }
        return layer;
      });
      return newImageState;

    case FIRST_TEXT_INITIAL_POSITION:
      let firstTextState = { ...state };

      firstTextState.layer_set = firstTextState.layer_set.map((old_layer) => {
        const layer = { ...old_layer };

        if (layer.layer_id === action.payload.layerId) {
          const layerCenterX = layer.width / 2,
            elementCenterX = action.payload.width / 2,
            difference = layerCenterX - elementCenterX;

          layer.text_elements = [
            ...layer.text_elements.slice(0, action.payload.index),
            {
              ...layer.text_elements[action.payload.index],
              left_position: difference,
            },
            ...layer.text_elements.slice(action.payload.index + 1),
          ];
        }
        return layer;
      });
      return firstTextState;

    case NEW_TEXT_INITIAL_POSITION:
      let newText = { ...state };

      newText.layer_set = newText.layer_set.map((old_layer) => {
        const layer = { ...old_layer };

        if (layer.layer_id === action.payload.layerId) {
          const layerCenterX = layer.width / 2,
            elementCenterX = action.payload.width / 2,
            difference = layerCenterX - elementCenterX;

          layer.text_elements = [
            ...layer.text_elements.slice(0, action.payload.index),
            {
              ...layer.text_elements[action.payload.index],
              left_position: difference,
            },
            ...layer.text_elements.slice(action.payload.index + 1),
          ];
        }
        return layer;
      });
      return newText;

    default:
      return state;
  }
}
